import { render, staticRenderFns } from "./analyticsTabChartComponent.vue?vue&type=template&id=2be57d9f"
import script from "./analyticsTabChartComponent.vue?vue&type=script&lang=js"
export * from "./analyticsTabChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports